export const config = {
	HOME_ROUTE: 'dashboard',
	REQUIRE_LOGIN: true,
};

export default config;
